import Keycloak from 'keycloak-js';
import jwt_decode from "jwt-decode";

import { isEmptyObject } from 'jquery';

const keycloakConfig:Keycloak.KeycloakConfig={
    url:process.env.REACT_APP_KEYCLOAK_URL,
    realm:process.env.REACT_APP_KEYCLOAK_REALM ? process.env.REACT_APP_KEYCLOAK_REALM : '',
    clientId:process.env.REACT_APP_KEYCLOAK_CLIENTID ? process.env.REACT_APP_KEYCLOAK_CLIENTID:'',
};

const keycloak: Keycloak.KeycloakInstance = Keycloak(keycloakConfig);
export default keycloak;

export const getLocaleKeycloak=()=>{
  const token:any=keycloak.token;
  
  if (!isEmptyObject(keycloak.token)){
    const decoded:any = jwt_decode(token);
    return decoded.locale;
  }
  return "";
}


export const keycloakProviderInitConfig={
    onLoad:"login-required",
  };

export const isLoadingCheck = (keycloak:any) => {
    return !keycloak.authenticated
 };

 export const storeToken = (token:string) => {
   //if(token!="")
   localStorage.setItem("keycloakToken", token);
}

export const updateToken=()=>{
  keycloak.updateToken(180).then(
    (response:any) => {
       //update existing Token HERE
       console.log("update token")
       console.log(response)
    })
    .catch((error:any) => {
      console.log("update token error")
        console.log("error: ", error)
    })
}


